import { render, staticRenderFns } from "./CLiveDate.vue?vue&type=template&id=40d70318&"
import script from "./CLiveDate.vue?vue&type=script&lang=ts&"
export * from "./CLiveDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports